import React from "react";
import AdminOrganizationTable from "../../../../components/Administration/AdminOrganizationTable";
import Applet from "../../Applet";

class AdminOrganizationTableApplet extends Applet {

    render() {
        return <AdminOrganizationTable applet={this}
                                       pageSize={this.state.PageSize}
                                       placement={this.state.Placement}
                                       columns={this.state.Columns}
                                       title="Organizations"
                                       enterpriseComponent={this.getEnterpriseComponent()}
                                       sort={this.state.Sort}
                                       menu={this.state.Menu}
                                       rowHeight={this.state.RowHeight}
        />;
    }

    state = {
        Name: "AdminOrganizationTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "New Organization",
                    value: "New Organization",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 50,
        PageSize: {
            "default": 5,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 10,
            "lx": 10,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Name",
                },
                {
                    id: "OrganizationType",
                },
                {
                    id: "ParentOrganizationName",
                },
                {
                    id: "Status",
                },
                {
                    id: "Actions",
                },
            ],
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "Name",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "OrganizationType",
                width: 200,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Organization Type",
            },
            {
                id: "ParentOrganizationName",
                width: 300,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Parent Organization",
            },
            {
                id: "Status",
                width: 200,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Status",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                }],
            },
        ],
    };
}

export default AdminOrganizationTableApplet;
